(() => {
  function init(root = document) {
    root.querySelectorAll('.spk-pre-compare input[type="range"]').forEach(input => {
      if (input.dataset.ready) return;
      input.dataset.ready = 'true';
      input.addEventListener('input', () => input.parentElement.style.setProperty('--split', `${input.value}%`));
    });
    root.querySelectorAll('.spk-pre-form').forEach(form => {
      if (form.dataset.ready) return;
      form.dataset.ready = 'true';
      const phone = form.elements.phone;
      phone.addEventListener('input', () => phone.setCustomValidity(''));
      form.addEventListener('submit', async event => {
        event.preventDefault();
        if (form.dataset.submitting === 'true') return;
        let number = phone.value.trim().replace(/[\s().-]/g, '');
        if (/^\d{10}$/.test(number)) number = '+1' + number;
        if (/^1\d{10}$/.test(number)) number = '+' + number;
        if (/^00/.test(number)) number = '+' + number.slice(2);
        if (!/^\+[1-9]\d{7,14}$/.test(number)) {
          phone.setCustomValidity(form.dataset.phoneError);
          phone.reportValidity();
          return;
        }
        if (!form.reportValidity()) return;
        const button = form.querySelector('button[type="submit"]');
        const status = form.querySelector('[role="status"]');
        const payload = {
          data: {
            type: 'subscription',
            attributes: {
              custom_source: `SPEK ${form.dataset.model.toUpperCase()} presale ${form.dataset.language.toUpperCase()}`,
              profile: { data: { type: 'profile', attributes: {
                email: form.elements.email.value.trim(),
                phone_number: number,
                locale: form.dataset.language === 'fr' ? 'fr-CA' : 'en-CA',
                properties: { [`prevente_${form.dataset.model}`]: true },
                // Explicit email-only consent: phone collection must not opt a visitor into SMS.
                subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
              } } }
            },
            relationships: { list: { data: { type: 'list', id: form.dataset.list } } }
          }
        };
        form.dataset.submitting = 'true';
        button.disabled = true;
        form.setAttribute('aria-busy', 'true');
        status.textContent = '';
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 20000);
        try {
          const response = await fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${encodeURIComponent(form.dataset.company)}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/vnd.api+json', accept: 'application/vnd.api+json', revision: '2026-07-15' },
            body: JSON.stringify(payload),
            signal: controller.signal
          });
          if (!response.ok) throw new Error('Signup rejected');
          status.dataset.state = 'success';
          status.textContent = form.dataset.success;
          form.reset();
        } catch (_) {
          status.dataset.state = 'error';
          status.textContent = form.dataset.error;
        } finally {
          clearTimeout(timeout);
          button.disabled = false;
          form.dataset.submitting = 'false';
          form.removeAttribute('aria-busy');
        }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
